import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as DeviceManager from '../domain/device-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { DevicePropertiesDetails } from '../../types/device';



//export type DeviceData = PromiseType<ReturnType<typeof DeviceManager.getDeviceProperties>>;
type ContextState = Data<DevicePropertiesDetails>;
const Context = React.createContext<ContextState | null>(null);

function useDeviceDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useDeviceDetails must be used within a DeviceDetailsProvider');
    }
    return contextState;
}

const DeviceDetailsProvider: React.FC<{ deviceId: string; recursive: boolean}> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'device-details',
        id: props.deviceId,
        dataFn: React.useCallback(() => DeviceManager.getDeviceProperties(authHelper, props.deviceId, props.recursive), [
            authHelper,
            props.deviceId,
            props.recursive
        ]),
    });

    const deviceDetailsData = dataFromDataset(dataset);

    return <Context.Provider value={deviceDetailsData}>{props.children}</Context.Provider>;
};

const TestDeviceDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { DeviceDetailsProvider, TestDeviceDataProvider, useDeviceDetails };
